module.exports = __webpack_public_path__ + "static/img/user.6b79e734.jpg";